import { fullName } from 'module/helpers/full-name';
import { Avatar } from 'module/ui/components/atoms/avatar';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { RelativeTime } from 'module/ui/components/atoms/relative-time';
import { Long01 } from 'module/ui/components/styles';
import { Color } from '@rocketlane/ui';
import { Tooltip } from 'antd';
import { Document } from 'api/pages';
import moment, { ISO_8601 } from 'moment';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CollaborationUser } from '../document-editor/collaborative-editor';

const SavedInfo = styled.div`
  ${Long01};
  opacity: 0.7;
`;
const Wrapper = styled(CenterAlignedBox)``;
const AvatarGroupWrapper = styled.div`
  display: flex;
  gap: var(--spacing-03);
`;
const AvatarWrapper = styled.div<{ $color: Color }>`
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: var(--spacing-01);
  border: 1px solid ${({ $color }) => `var(--${$color}-60)`};
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  document: Document;
  activeUsersFromCollaboration: CollaborationUser[];
}
export const DocumentPageHeaderActions = ({
  document,
  activeUsersFromCollaboration,
}: Props) => {
  return (
    <Wrapper>
      <SavedInfo>
        <FormattedMessage
          id="meeting_document.header.saved_at"
          values={{
            time: (
              <RelativeTime
                time={moment(
                  document.metadata.updatedAt ?? document.metadata.createdAt,
                  ISO_8601,
                )}
              />
            ),
          }}
        />
      </SavedInfo>
      <AvatarGroupWrapper>
        {activeUsersFromCollaboration.map((user) => (
          <Tooltip
            key={user?.actualUser?.userId}
            title={fullName(user?.actualUser)}
            placement="left"
          >
            <AvatarWrapper
              onClick={() => {
                window.document
                  .querySelector(
                    `[data-collaboration-user-id="${user?.actualUser?.userId}"]`,
                  )
                  ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }}
              $color={user?.color}
            >
              <Avatar
                key={user?.actualUser?.userId}
                src={user?.actualUser?.photoUrl}
                name={fullName(user?.actualUser)}
                size={16}
              />
            </AvatarWrapper>
          </Tooltip>
        ))}
      </AvatarGroupWrapper>
    </Wrapper>
  );
};
